<ng-container *ngIf="!allComponentsLoaded">
  <div class="skeleton-text"></div>
</ng-container>
<ng-container *ngIf="allComponentsLoaded && hasError">
  <span>{{placeholder}}</span>
</ng-container>
<ng-container *ngIf="allComponentsLoaded && !hasError">
  <ng-content></ng-content>
</ng-container>
